export default __webpack_public_path__ + "static/media/openvino-toolkit.51285684.svg";